import { toUtc } from "@/lib/mood";
import { RefundButton } from "@/components/admin/RefundButton";

const money = (n, c) => Number(n || 0).toLocaleString("en-US", { style: "currency", currency: c || "USD" });
const STATUS = { paid: "bg-emerald-100 text-emerald-700", refunded: "bg-amber-100 text-amber-700" };

export const RecentPurchases = ({ items, onChange }) => (
  <div className="mm-card mt-4 overflow-x-auto" data-testid="admin-recent-purchases">
    <h3 className="font-semibold p-5 pb-2">Recent purchases</h3>
    {items.length === 0 ? (
      <p className="text-sm text-mm-muted px-5 pb-5" data-testid="admin-recent-purchases-empty">No purchases yet.</p>
    ) : (
      <table className="w-full text-sm">
        <thead><tr className="text-left text-mm-muted border-b"><th className="px-5 py-3">Customer</th><th className="px-5 py-3">Amount</th><th className="px-5 py-3">Method</th><th className="px-5 py-3">Status</th><th className="px-5 py-3">Date</th><th className="px-5 py-3" /></tr></thead>
        <tbody>
          {items.map((p, i) => (
            <tr key={p.id || `${p.email}-${p.date || i}`} className="border-b last:border-0" data-testid={`admin-purchase-${p.id || i}`}>
              <td className="px-5 py-3 font-medium">{p.email}</td>
              <td className="px-5 py-3">{money(p.amount, p.currency)}</td>
              <td className="px-5 py-3 capitalize">{p.provider}</td>
              <td className="px-5 py-3"><span className={`px-2 py-0.5 rounded-full text-xs font-semibold capitalize ${STATUS[p.status] || ""}`}>{p.status}</span></td>
              <td className="px-5 py-3 text-mm-muted">{p.date ? new Date(toUtc(p.date)).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—"}</td>
              <td className="px-5 py-3">{p.status === "paid" && <RefundButton purchase={p} onDone={onChange} />}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
);
